import * as React from "react";
const SvgWarning = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM13.5 17H11.5V15H13.5V17ZM13.5 13H11.5V7H13.5V13Z",
	fill: "currentColor"
}));
export default SvgWarning;
